import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FlashMessagesService} from "angular2-flash-messages";
import {HttpService} from "../../_service/http.service";
import {PasswordService} from "../../password.service";
import {OrganizationService} from "../../_service/organization.service";
import {PhoneService} from "../../phone/phone.service";
import {WelcomeMainComponent} from "../welcome-part.component";

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {

  model: any = {
    numberPrefix: '+7'
  };
  passwordAndLoginAreCorrect: boolean = false;
  passwordErrorMessage: string = "";
  isPhoneUnique = true;
  errorMessage: string = "";
  isOrgHasSmsConfirmation: boolean;
  isAgreed: boolean;

  constructor(private httpService: HttpService, private passwordService: PasswordService,
              private router: Router, private flashMessagesService: FlashMessagesService,
              private route: ActivatedRoute, private orgService: OrganizationService,
              public welcomeMainComponent: WelcomeMainComponent,
              private phoneService: PhoneService) {
  }

  ngOnInit() {

    this.orgService.isHasSmsConfirmation(localStorage.getItem("organizationAlias"))
      .then((isHasSmsConfirmation) => {
        this.isOrgHasSmsConfirmation = isHasSmsConfirmation;
      });

    this.isAgreed=false;
  }

  async checkPasswordAndPhone() {

    if (!PhoneService.isPhoneNumberCorrect(this.model.phone)) {
      this.flashMessagesService.show("Номер телефона введен в неверном формате",
        {cssClass: 'alert alert-danger danger-font small', timeout: 5000});
      return false;
    }

    if (!this.isPasswordCorrect()) {
      return false;
    }

    await this.checkIsPhoneUnique();

    this.passwordAndLoginAreCorrect = this.isPasswordCorrect() && this.isPhoneUnique;

    console.log("this.passwordAndLoginAreCorrect ", this.passwordAndLoginAreCorrect);

    if (!this.passwordAndLoginAreCorrect) {
      return false;
    }

    if (this.isOrgHasSmsConfirmation) {
      return this.passwordAndLoginAreCorrect;
    }

    this.registerNewUser();

    return this.passwordAndLoginAreCorrect;
  }

  // Вызывается при введении пароля
  handlePassword(event) {
    // console.log("Handle password event is: ", event);
    this.model.password = event;
  }

  // Вызывается при введении кода подтверждения
  handleCodeCheck(event) {
    if (event.isCodeCorrect) {
      this.registerNewUser();
    } else {
      return;
    }
  }

  async registerNewUser() {

    console.log("Registration model is ", this.model);
    const sb = [];
    sb.push('rest/' + localStorage.getItem('organizationAlias') + '/registerNewUser');

    const result = {
      phone: this.model.numberPrefix + this.model.phone,
      password: this.model.password
    };


    await this.httpService.postData(sb.join(''), JSON.stringify(result))
      .then(data => {

        this.welcomeMainComponent.onMainMessage = "Вы успешно зарегистрировались." +
          " Для перехода на сайт авторизируйтесь в форме ниже.";

        this.router.navigate(["../login"], {relativeTo: this.route});

      }, error => {
        this.flashMessagesService.show(JSON.parse(error._body).errorTitle,
          {cssClass: 'alert alert-danger danger-font small', timeout: 5000});

      });
  }

  async checkIsPhoneUnique() {

    const sb = [];
    sb.push('rest/' + localStorage.getItem('organizationAlias') + '/isPhoneUnique?');
    sb.push('&phoneNumber=');
    sb.push(encodeURIComponent(this.model.numberPrefix + this.model.phone));

    await this.httpService.getData(sb.join(''))
      .then(isPhoneUnique => {
        console.log("Registration: ", isPhoneUnique);
        this.isPhoneUnique = isPhoneUnique;

        if (!isPhoneUnique) {
          this.flashMessagesService.show("Вы уже зарегистрированы, выполните вход.",
            {cssClass: 'alert alert-danger danger-font small', timeout: 5000});
        }
      }, error => {
        console.log("isPhoneUnique: error", error);

        this.flashMessagesService.show(JSON.parse(error._body).errorTitle,
          {cssClass: 'alert alert-danger danger-font small', timeout: 5000});

        this.router.navigate(["../login"], {relativeTo: this.route});
      });
  }

  isPasswordCorrect(): boolean {
    this.passwordErrorMessage = this.passwordService.checkPassword(this.model.password);
    return this.passwordErrorMessage == "";
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/tmpName/registration/registration.component.ts